export default "__VITE_ASSET__7AC65VlQ__"